/* istanbul ignore file */
// TODO: Create test file
import { fireTag } from '@common-vue/util/src/modules/tagManager';

export function fireLinkTag(tagData) {
  fireTag('link', tagData);
}

export function fireViewTag(tagData) {
  fireTag('view', tagData);
}
